import styled, { css, keyframes } from "styled-components";
import ScheduleType from "./ScheduleType";

interface ITDSchedules {
  status: number;
  isSelected: number;
  appointmentCount?: number;
}

export const Container = styled.div``;

export const Content = styled.div`
  max-width: min(1680px, 100%);

  margin: 0 auto;

  display: flex;
  align-items: center;
  justify-content: center;

  flex-direction: column;

`;

export const ErrorMessageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 75vh;

  > h2 {
    width: 60%;

    text-align: center;

    color: #ff5252;
  }
`;

export const SchedulesContainer = styled.div`
  padding: 16px;

  border-radius: 4px;

  margin-top: 12px;
  width: 100%;
  h3 {
    font-size: 1.375rem;
    font-weight: 700;
    line-height: 1.25;
    text-align: left;
    color: #444444;
    margin: 0;
  }

  .bottom-line {
    margin-top: 8px;
    width: 48px;
    height: 2px;
    background-color: #dd6434;
    border-radius: 999px;
  }

  .header-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;

    @media (max-width: 767px) {
      flex-direction: column;
      align-items: stretch;
    }
  }

  .title-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
    flex: 1;
  }

  @media (max-width: 767px) {
    width: 100%;
    padding: 24px 12px;
  }
`;

export const SchedulesContent = styled.div`
  max-width: 100%;
  margin-top: 20px;
  width: 100%;

  &.agenda-grid-surface {
    overflow: visible;
  }

  overflow: auto;

  .table-hide {
    display: none;
    transition: height 0.5s;
  }
  
  .table-show {
    width: 100%;
    margin: 24px 0 12px;
    border-radius: 16px;
    overflow: hidden;
    @media(max-width: 767px){ 
      overflow: auto;
    }
  }

  thead {
    display: block;
    width: 100%;

    tr {
      display: flex;
      @media(max-width: 767px){
        display: block;
      }
    }
    th {
      display: inline-block;
    }
    .th-city {
      background: #dd6434;
      color: #ffffff;

      text-align: center;
      font-size: 14px;
      font-weight: bold;
      text-transform: uppercase;

      padding: 16px 0;
      width: 14%;
      height: 48px;
      margin-right: 1%;

      @media(max-width: 767px){
        position: sticky;
        left: 0;
        width: 22.5%;
        white-space: wrap;
      }
    }
    .th-hour {
      padding: 12px 29px;
      background-color: #9b9b9b;
      height: 48px;
      font-size: 14px;
      font-weight: 600;
      color: #ffffff;
      text-align: center;
      padding: 16px 0;
      width: 8.5%;

      @media(max-width: 767px){
        width: 12.9%;

      }
    }
  }

  tbody {
    width: 100%;
    display: block;

    tr {
      margin-top: 12px;
      display: block;
      
      .td-consultant {
        text-align: center;
    
        width: 14%;
        height: 3rem;
    
        font-size: 14px;
        color: #666666;
    
        padding: 16px 4px;
        background: #f9f9f9;
        font-weight: 500; 
  
        @media(max-width: 767px){
          position: sticky;
          left: 0;
          width: 22.5%;
          padding: 4px;
          z-index: 5;
          >p {
            display: flex;
            height: 100%;
            align-items: center;
            white-space: wrap;
            justify-content: center;
          }
        }
      }
      @media (min-width: 767px) {
        &:last-of-type {
          > td:last-of-type {
            border-radius: 0 0 1rem 0;
          }
        } 
      }
    }
    
    td {
      display: inline-block;
      user-select: none;
  
      &::selection {
        background: none;
      }
  
      &::-moz-selection {
        background: none;
      }
    }
  }

  @media (max-width: 767px) {
    white-space: nowrap;
  }
`;

export const WeekdayTitle = styled.div`

  background-color: #6ea5ff;
  color: #ffffff;

  cursor: pointer;

  display: flex;

  padding: 12px 0;

  border-radius: 16px;

  > h4 {
    margin: 0 auto;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
  }

  > svg {
    align-items: center;
    font-size: 20px;
    text-align: right;
    margin-right: 16px;
  }

  @media(max-width: 767px){
    position: sticky;
    left: 0;
  }
`;

export const TDSchedules = styled.td<ITDSchedules>`
  ${(props) =>
    props.status === ScheduleType.LOCKED &&
    css`
      border: 2px solid ${
        props.isSelected >= 0 ? "#dee2e6" : "hsl(360deg 100% 45%)"
      };
      >svg {
        color: ${props.isSelected >= 0 ? "#dee2e6" : "hsl(360deg 100% 45%)"}
      }
    `}

  ${(props) =>
    props.status === ScheduleType.UNLOCKED &&
    css`
      background-color: ${props.isSelected >= 0 ? "#dee2e6" : "#FFFFFF"};
      border: 1.5px solid #d7d7d7;
    `}

  ${(props) =>
    props.status === ScheduleType.SCHEDULED &&
    css`
    border: 2px solid ${
      props.isSelected >= 0 ? "#dee2e6" : "hsl(112deg 99% 28%)"
    };
    >svg {
      color: ${props.isSelected >= 0 ? "#dee2e6" : "hsl(112deg 99% 28%)"}
    }
  `}
    
    width: 7.6%;
    margin-left: 1%;
    height: 48px;

    >svg {
      display: block;
      margin: auto;
      pointer-events: none;
      margin-top: 10px;
    }

    @media(max-width: 767px){
      width: 12%;
      height: 3rem;
    }
`;

export const SearchContainer = styled.div<{ isExpanded: boolean }>`
  position: relative;
  width: ${({ isExpanded }) => (isExpanded ? "420px" : "44px")};
  min-width: ${({ isExpanded }) => (isExpanded ? "420px" : "44px")};
  transition: width 0.25s ease, min-width 0.25s ease;
  margin-left: auto;

  .search-toggle-button,
  .search-close-button {
    width: 44px;
    height: 44px;
    border: 1px solid #d9d9d9;
    border-radius: 10px;
    background: #ffffff;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      border-color: #dd6435;
      color: #dd6435;
      box-shadow: 0 4px 12px rgba(221, 100, 53, 0.12);
    }
  }

  .search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .search-icon {
    position: absolute;
    left: 14px;
    color: #9a9a9a;
    pointer-events: none;
  }

  .search-close-button {
    position: absolute;
    right: 4px;
    width: 36px;
    height: 36px;
    border: 0;
    background: transparent;
    box-shadow: none;

    &:hover {
      background: #f7f7f7;
    }
  }

  @media (max-width: 767px) {
    width: ${({ isExpanded }) => (isExpanded ? "100%" : "44px")};
    min-width: ${({ isExpanded }) => (isExpanded ? "100%" : "44px")};
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 48px;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  padding: 0 44px 0 42px;
  font-size: ${14 / 16}rem;
  color: #666666;
  background: #fff;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: #9a9a9a;
  }

  &:focus {
    border-color: #dd6435;
    box-shadow: 0 0 0 2px rgba(221, 100, 53, 0.12);
  }

  @media (max-width: 767px) {
    height: 44px;
    font-size: ${13 / 16}rem;
    padding: 0 40px 0 38px;
  }
`;

export const SearchDropdown = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  right: 0;
  background: #ffffff;
  border: 1px solid #ececec;
  border-radius: 14px;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.12);
  z-index: 20;
  max-height: 380px;
  overflow-y: auto;
  padding: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #dd6435;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #c1552b;
  }

  @media (max-width: 767px) {
    max-height: 320px;
  }
`;

export const SearchEmptyState = styled.div`
  padding: 14px 16px;
  font-size: ${14 / 16}rem;
  color: #666666;

  @media (max-width: 767px) {
    font-size: ${13 / 16}rem;
    padding: 12px 14px;
  }
`;

export const SearchLoadingState = styled(SearchEmptyState)``;

export const SearchResultButton = styled.button`
  width: 100%;
  border: 1px solid #f0f0f0;
  background: #ffffff;
  text-align: left;
  padding: 16px 18px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);

  & + & {
    margin-top: 8px;
  }

  &:hover {
    background: #faf7f5;
    transform: translateY(-1px);
  }

  @media (max-width: 767px) {
    padding: 13px 14px;
  }
`;

export const SearchResultTitle = styled.div`
  font-size: ${15 / 16}rem;
  font-weight: 700;
  color: #444444;
  line-height: 1.35;

  @media (max-width: 767px) {
    font-size: ${14 / 16}rem;
  }
`;

export const SearchResultMeta = styled.div`
  font-size: ${12 / 16}rem;
  color: #777777;
  line-height: 1.5;

  strong {
    color: #555555;
    font-weight: 600;
  }

  & + & {
    margin-top: 4px;
  }

  @media (max-width: 767px) {
    font-size: ${11 / 16}rem;
  }
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const SearchLoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  color: #666666;
  font-size: ${14 / 16}rem;

  @media (max-width: 767px) {
    font-size: ${13 / 16}rem;
    padding: 12px 14px;
  }
`;

export const SearchLoadingSpinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid #f1f1f1;
  border-top: 2px solid #dd6435;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  flex-shrink: 0;
`;

export const SearchLoadingText = styled.span`
  color: #666666;
`;

export const SearchResultTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;

  @media (max-width: 767px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
`;

export const SearchResultDateBadge = styled.span`
  flex-shrink: 0;
  background: #fdf1eb;
  color: #c45a2f;
  border: 1px solid #f3d4c5;
  border-radius: 999px;
  padding: 6px 10px;
  font-size: ${11 / 16}rem;
  font-weight: 600;
  line-height: 1.2;

  @media (max-width: 767px) {
    font-size: ${10 / 16}rem;
  }
`;

export const SearchResultAddress = styled.div`
  margin-top: 8px;
  font-size: ${12 / 16}rem;
  color: #777777;
  line-height: 1.5;

  strong {
    color: #555555;
    font-weight: 600;
  }

  @media (max-width: 767px) {
    font-size: ${11 / 16}rem;
  }
`;
